import React from 'react';
import { currentInvestment } from '../../../models/Investor';
import ExtendedLiquid from '../../../services/ExtendedLiquid';
import InvestorRowActions from '../FundOpportunityAdmin/InvestorRowActions';
import type { PipelineStageActionLabels } from '../FundOpportunityAdmin/pipelineStageActionLabels';
import PipelineRowCard from '../PipelineRowCard';
import { FundOpportunityWithInvestor } from './contactFundOpportunityKanbanTypes';

interface ContactFundOpportunityPipelineRowProps {
  opportunity: FundOpportunityWithInvestor;
  labels: PipelineStageActionLabels;
  onPromote?: () => void;
  onDemote?: () => void;
  onDelete?: () => void;
}

export default function ContactFundOpportunityPipelineRow({
  opportunity,
  labels,
  onPromote,
  onDemote,
  onDelete,
}: ContactFundOpportunityPipelineRowProps) {
  const { investor } = opportunity;

  return (
    <PipelineRowCard
      className="opportunity-card"
      data-fund-opportunity-id={opportunity.id}
      title={opportunity.name || 'Unnamed Opportunity'}
      subtitle={
        opportunity.fundSize
          ? `Fund size: ${ExtendedLiquid.currencyMillions(opportunity.fundSize, true)}`
          : undefined
      }
      amount={
        investor ? currentInvestment(investor as Parameters<typeof currentInvestment>[0]) : null
      }
      viewLinks={{
        investor: investor
          ? `/opportunities/${opportunity.id}/investors/${investor.id}`
          : undefined,
        fund: `/opportunities/${opportunity.id}`,
      }}
      actions={
        <InvestorRowActions
          contact={{ onPromote, onDemote, onDelete }}
          promotionStageLabel={labels.promotionLabel}
          demotionStageLabel={labels.demotionLabel}
        />
      }
    />
  );
}
